import {
  SECTION_LIST, 
  SECTION_LIST_SUCCESS, 
  SECTION_LIST_ERROR,
  SECTION_SEARCH_SET, 
  SECTION_SEARCH_CHANGE, 
  SECTION_PAGE_SET,
  SECTION_SEARCH_ASSESSMENT_LIST,
  SECTION_SEARCH_ASSESSMENT_LIST_SUCCESS,
  SECTION_SEARCH_ASSESSMENT_LIST_ERROR,
  SECTION_ADD_SET,
  SECTION_ADD_MODAL_SET,
  SECTION_ADD,
  SECTION_ADD_SUCCESS,
  SECTION_ADD_ERROR,
  SECTION_ADD_CHANGE,
  SECTION_DETAIL,
  SECTION_DETAIL_SUCCESS,
  SECTION_DETAIL_ERROR,
  SECTION_VIEW_MODAL_SET,
  SECTION_EDIT_CHANGE,
  SECTION_EDIT_MODAL_SET,
  SECTION_UPDATE,
  SECTION_UPDATE_SUCCESS,
  SECTION_UPDATE_ERROR,
  SECTION_VIEW_TAB_SET,
  SECTION_UPLOAD_SET,
  SECTION_UPLOAD_SET_SUCCESS,
  SECTION_UPLOAD_SET_ERROR,
  SECTION_UPLOAD_RESET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 10
    }
  },
  add: {
      data: {
        new:{ id_assessment: null, assessment: null, code: '', name: '', description: '', if_select: false, url_file: '', original_file_name: '', file_name: '' }
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      assessment: false
    },
    value:{
      assessment: false,
    },
    assessment:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SECTION_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case SECTION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case SECTION_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case SECTION_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case SECTION_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case SECTION_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case SECTION_SEARCH_ASSESSMENT_LIST:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          assessment:{
            ...state.search.assessment,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case SECTION_SEARCH_ASSESSMENT_LIST_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case SECTION_SEARCH_ASSESSMENT_LIST_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          assessment:{
            ...state.search.assessment,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case SECTION_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case SECTION_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case SECTION_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_assessment: null, assessment: null, code: '', name: '', description: '', if_select: false, url_file: '', original_file_name: '', file_name: ''}
          },
          modal: action.payload
        }
      }
    case SECTION_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case SECTION_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case SECTION_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case SECTION_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case SECTION_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case SECTION_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case SECTION_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case SECTION_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case SECTION_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case SECTION_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case SECTION_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case SECTION_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case SECTION_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case SECTION_UPLOAD_SET:
      return { ...state };
    case SECTION_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case SECTION_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case SECTION_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};